import { v4 as uuidv4 } from 'uuid'

import { TOAST_ADD, TOAST_REMOVE } from './constants'

export function addToast(params) {
  return (dispatch) =>
    dispatch({
      type: TOAST_ADD,
      toast: {
        id: uuidv4(),
        type: params.type,
        ...params,
      },
    })
}

function removeToast(id) {
  return (dispatch) =>
    dispatch({
      type: TOAST_REMOVE,
      toast: { id },
    })
}

export default {
  addToast,
  removeToast,
}
